import { Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import _ from 'lodash';
import React from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';
import styled from '@emotion/styled';

import { BREAKPOINTS, SPACE } from '@/constants';
import Checkbox from '@/components/checkbox';
import { SmallStyles } from '@/components/type';

import { ALL_ID } from './constants';

const Wrapper = styled.div`
  width: 100%;
  @media (min-width: ${BREAKPOINTS.MD}px) {
    margin-top: ${SPACE.X1};
  }
`;

const CheckboxWrapper = styled.div`
  ${SmallStyles};
  display: flex;
  justify-content: space-between;
  margin-top: ${SPACE.X1};
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  .MuiFormControlLabel-root {
    margin: 0;
    width: 100%;
    display: inline-flex;
    justify-content: space-between;
  }

  @media (min-width: ${BREAKPOINTS.MD}px) {
    display: inline-flex;
    align-items: center;
    margin-top: ${SPACE.X0};
  }
`;

const CheckboxLabelWrapper = styled.span`
  display: inline-flex;
  align-items: center;
`;

const StyledImg = styled.img`
  width: 67px;
  height: 26px;
  min-width: 67px;
  min-height: 26px;
  margin-right: ${SPACE.X0};
`;

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'checkbox' implicitly has an 'any' type.
const CheckboxLabel = ({ checkbox }) => (
  <CheckboxLabelWrapper>
    {checkbox.imageUrl && <StyledImg src={checkbox.imageUrl} alt={`Icon for car type: ${checkbox.label}`} />}
    {checkbox.label}
  </CheckboxLabelWrapper>
);

const CheckboxPanel = ({
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'checkboxes' implicitly has an 'any' type.
  checkboxes,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'setter' implicitly has an 'any' type.
  setter,
  columnsPerGridItem = 3,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'currentRefinement' implicitly has an 'any' type.
  currentRefinement,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'id' implicitly has an 'any' type.
  getExpandedValues = (id) => [id],
}) => {
  const isMobile = useMediaQuery(useTheme().breakpoints.down('md'));

  return (
    <Wrapper>
      <Grid container>
        {_.map(checkboxes, (checkbox) => {
          let checked;
          if (checkbox.id === ALL_ID) {
            checked = _.isEmpty(currentRefinement);
          } else {
            const expandedValues = getExpandedValues(checkbox.id);
            // A checkbox is checked if any of the expanded values are in the current refinement
            // Current refinement being an array of values that are going to be used to search the algolia index
            checked = expandedValues.some((value) =>
              Array.isArray(currentRefinement) ? currentRefinement.includes(value) : !!currentRefinement[value]
            );
          }

          return (
            <Grid key={checkbox.filterId + checkbox.id} {...{ item: true, xs: 12, md: columnsPerGridItem }}>
              <CheckboxWrapper
                onClick={() => {
                  setter(checkbox.id, !checked);
                }}
              >
                <Checkbox
                  isMobile={isMobile}
                  checked={checked}
                  label={<CheckboxLabel {...{ checkbox }} />}
                  handleChange={() => {}}
                />
              </CheckboxWrapper>
            </Grid>
          );
        })}
      </Grid>
    </Wrapper>
  );
};

const ConnectedCheckboxPanel = connectRefinementList(CheckboxPanel);
export const VirtualRefinementList = connectRefinementList(() => null);

export default ConnectedCheckboxPanel;
